import React from 'react';

import Header from '../partials/Header';
import ResourceList from '../partials/ResourceList';
import ResourceIntro from '../partials/ResourceIntro';

import CtaAlternative from '../partials/CtaAlternative';
import Footer from '../partials/Footer';

function Resources() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">

        {/*  Page sections */}
        <ResourceIntro />
        <ResourceList />
        <CtaAlternative />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Resources;